import { deleteMethods } from '@/components/tools'
import { tkRegions } from '@moke/vue-tk'
export default {
  className: 'shippingAddress',
  defaultOrder: '-createdAt',
  render: (record) => {
    return record.name + '-' + record.phone + '-' + tkRegions.getFullName(record.region) + ' ' + record.address
  },
  fields: [
  ],
  search: [
  ],
  action: {
    delete: {
      type: 'row',
      text: '删除',
      callback: deleteMethods
    }
  },
  hooks: {
    beforeFetch ({ where }) {
      where.isDeleted = {
        $ne: true
      }
    }
  }
}
